module.exports = __webpack_public_path__ + "statics/img/cate3-3@2x.62a25adc.png";